<template>
  <li class="zixunItem clearBoth" :class="min?'min':''"
      @click="intoInformationDetail(item.newsId,'information')">
    <div  v-if="min" class="zixunImgBox l" style="width:240px;height:142px;margin-bottom: 18px">
      <img v-bind:src="imgPath+item.image" :onerror="imgError" width="240" height="142"
           alt="资讯图片">
      <div class="zixunTime" v-if="item.videoUrl">{{item.videoDuration}}</div>
    </div>
    <div v-if="!min" style="width:268px;height: 160px" class="zixunImgBox l">
      <img  v-bind:src="imgPath+item.image" :onerror="imgError"  width="268" height="160"
           alt="资讯图片">
      <div class="zixunTime" v-if="item.videoUrl">{{item.videoDuration}}</div>
    </div>
    <div class="zixunContent">
      <h3 class="ellip">{{item.title}}</h3>
      <p class="details" v-html="item.summary && item.summary.length>90?item.summary.slice(0,87)+'...':item.summary"></p>
      <div class="origin">{{item.source && item.source.length>90?item.source.slice(0,87)+'...':item.source}}</div>
      <div class="zixunDate">
        <span>{{item.createDate}}</span>
        <span class="info r">{{item.viewCount}}次</span></div>
    </div>
  </li>
</template>

<script>
  import {store} from '../../src/store/store.js';
  import {imgPath} from "../common/config";

  export default {
    name: 'zixun',
    props: ['item','min'],
    data() {
      return {
        imgError: store.imgError,
        imgPath:imgPath
      }
    },
    mounted() {

    },
    methods:{
      intoInformationDetail(newsId,type) {
        this.$emit('toNewsInfo',newsId,type);
      },
    }
  }
</script>

<style scoped lang="sass">
  .clearBoth
    &:after
    clear: both
    content: ''
    overflow: hidden
    display: block

  .web2
    .zixunItem
      &:hover
        h3
          color: $themecolor2
  .min
    padding: 0!important
    height: 142px!important
    p, h3
      margin-bottom: 5px!important
    .zixunContent
      height: 142px!important
    .origin
      line-height: 20px!important
    &:hover
      background: #fff!important
  .zixunItem
    position: relative
    padding: 30px
    cursor: pointer
    .zixunImgBox
      margin-right: 30px
      position: relative
      .zixunTime
        ///*width: 77px*/
        padding-right: 10px
        height: 22px
        box-sizing: border-box
        padding-left: 22px
        background: url(../assets/images/video.png) 8px 7px no-repeat  rgba(0,0,0,.6)
        color: #ffffff
        border-radius: 11px
        font-size: 12px
        position: absolute
        right: 8px
        bottom: 8px
        line-height: 22px
    .zixunContent
      height: 160px
      .origin
        font-size: 14px
        line-height: 30px
        color: #333
      h3
        margin-bottom: 15px
        height: 30px
        font-size: 18px
        font-weight: normal
        line-height: 30px
        color: #333
      .details
        margin-bottom: 15px
        height: 48px
        font-size: 14px
        line-height: 24px
        color: #333
      .zixunDate
        margin-top: 6px
        font-size: 14px
        line-height: 14px
        color: #666
      .info
        padding-left: 22px
        width: 70px
        font-size: 14px
        line-height: 14px
        color: #999
        background: url("../assets/images/eyes.png") left center no-repeat
        cursor: pointer
    &:hover
      background: #f8f8f8
      img
        opacity: 0.8
      h3
        color: $col_cb
        text-decoration: underline
</style>
